import { useReactiveVar } from '@apollo/client'
import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { IconButton, makeStyles } from '@material-ui/core'
import { userInfo } from 'api/graphQL/reactiveVars/user'
import ChatLauncherIconHeader from 'components/RightPane/ChatLauncherIconHeader'
import { ProjectPageContext } from 'pages/ProjectsPage/ProjectPage/components/ProjectPageContext'
import { saveToLocalStorage } from 'pages/ProjectsPage/WorkspacePage'
import React, { useContext } from 'react'
import { getFromLocalStorage } from 'shared/utils/workspaceUtils'
import AskDelaChatContainer from './AskDelaChatContainer'
import { ChatInstanceId, useChatInstanceId } from './useChatInstanceId'

const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
    },
    chatContainer: {
        position: 'absolute',
        top: '60px',
        right: '0',
        height: 'calc(100vh - 60px)',
        width: '450px',
        background: '#fff',
        borderRadius: '24px 0 0 24px',
        overflow: 'hidden',
        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
    },
    delaButton: {
        margin: pxToRem(3),
        marginRight: pxToRem(20),
        borderRadius: pxToRem(4),
        color: '#ffffff',
    },
    delaIcon: {
        fill: '#ffffff',
    },
}))

const DelaHeaderHOC = () => {
    const classes = useStyles()
    const { projectId } = useContext(ProjectPageContext)

    const {
        currentUserInfo: { kpUserId: userId },
    } = useReactiveVar(userInfo)

    const updatePersistentStateValues = React.useCallback(
        (propKey: string, inputValue: boolean | any) => {
            saveToLocalStorage(propKey, inputValue, userId, projectId)
        },
        [userId, projectId]
    )

    const getPersistedState = React.useCallback(
        (propKey: string) => {
            return getFromLocalStorage(userId, projectId!, propKey)
        },
        [userId, projectId]
    )
    const [isDelaOpen, setIsDelaOpen] = React.useState<boolean | undefined>(
        getPersistedState?.('isDelaOpen') ?? false
    )

    const toggleDela = React.useCallback(() => {
        updatePersistentStateValues?.('isDelaOpen', !isDelaOpen)
        setIsDelaOpen(!isDelaOpen)
    }, [isDelaOpen])

    const [chatInstanceId] = React.useState<ChatInstanceId>(
        useChatInstanceId('header')
    )

    return (
        <div className={classes.container}>
            <HoverTooltip
                text="Ask Dela"
                placements={['left']}
                data-testid="delaChatButton"
                aria-label="Dela"
            >
                <IconButton
                    size="small"
                    onClick={toggleDela}
                    className={classes.delaButton}
                    aria-label="Open Dela"
                >
                    <ChatLauncherIconHeader className={classes.delaIcon} />
                </IconButton>
            </HoverTooltip>
            {isDelaOpen && (
                <div className={classes.chatContainer}>
                    <AskDelaChatContainer chatInstanceId={chatInstanceId} />
                </div>
            )}
        </div>
    )
}

export default DelaHeaderHOC
